// @ts-nocheck
import { resultTypeToAffix } from "~/util/search";
import { CONFIG } from "~/config";
import HistorySuggestItem from "~/es6/history.suggest.item";
import SuggestProvider from "~/suggestprovider";
import SuggestOverlay from "~/util/suggest-overlay";
import { store } from "~/state/store";

export default class MapySuggest {
	constructor(optsArgs) {
		this._opts = {
			input: null,
			// data { query, suggestData, results }
			onSuggest: () => {},
			onSuggestOpen: () => {},
			onSuggestClose: () => {},
			// data { query }
			onSuggestEnter: () => {},
			...optsArgs,
		};
		this._suggestRequestItems = [];
		this._suggest = null;

		this._build();
	}

	destroy() {
		this._overlay.destroy();
	}

	get suggest() {
		return this._suggest;
	}

	_build() {
		this._suggest = new SMap.Suggest(this._opts.input, {
			factory: (data, pos) => new HistorySuggestItem(data, pos),
			provider: new SuggestProvider({
				url: `${CONFIG.requestUrl}/suggest/`,
				poiaggUrl: `${CONFIG.requestUrl}/poiagg`,
				limit: 8,
			}),
			abTest: CONFIG.abTest ? CONFIG.abTest.flags : "",
			// klic flag: userweb_no_suggest_delay
			delay: Mapy.CUS.userweb && Mapy.CUS.userweb.userweb_no_suggest_delay ? 0 : 400,
		});
		this._suggest
			.addListener("suggest", suggestData => {
				this._suggest.close();
				this._overlay.hide();
				// vysledky pro analytiku
				const results = this._suggestRequestItems.slice(0, 10).map(item => `${item.source}_${item.id}${resultTypeToAffix(item.resultType, item.mmsource)}`);

				// event
				this._opts.onSuggest({
					query: this._suggest.getPhrase(),
					suggestData,
					results,
				});
			})
			.addListener("request-items", suggestData => {
				this._suggestRequestItems = suggestData;
			})
			.addListener("request", () => {
				this._suggestRequestItems = [];
			})
			.addListener("enter", () => {
				this._overlay.hide();
				this._opts.onSuggestEnter({
					query: this._suggest.getPhrase(),
				});
			})
			.addListener("open", () => {
				this._overlay.show();
				this._opts.onSuggestOpen();
			})
			.addListener("close", () => {
				this._overlay.hide();
				this._opts.onSuggestClose();
			});
		this._suggest.getProvider().updateParams(paramsObj => {
			const state = store.getState();
			const { user } = state.user;
			const { longitude, latitude, zoom } = state.map;

			paramsObj.lon = longitude;
			paramsObj.lat = latitude;
			paramsObj.zoom = zoom;
			paramsObj.enableCategories = 1;
			paramsObj.lang = CONFIG.langPriority.join(",");
			paramsObj.personalize = user.state === "green" ? 1 : 0;
			paramsObj.includeNonEntityTypes = 1;
			paramsObj.count = 8;

			if (Mapy.userLocation.position) {
				paramsObj.userLat = Mapy.userLocation.position.lat;
				paramsObj.userLon = Mapy.userLocation.position.lon;
				paramsObj.userAccuracy = Mapy.userLocation.position.accuracy;
			}
		});

		this._overlay = new SuggestOverlay(this._opts.input);
	}
}
